module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZS8+PC9kZWZzPjxwYXRoIGQ9Ik01MTMgNTgzLjhsNDQ4LjUtNDQ4LjVjLTExLjYtNC43LTI0LjMtNy4zLTM3LjUtNy4zSDEwMGMtMTIuNyAwLTI0LjkgMi40LTM2LjEgNi43TDUxMyA1ODMuOHoiLz48cGF0aCBkPSJNNTEzIDY3NC4zTDE0LjYgMTc1LjlDNS4zIDE5MS4xIDAgMjA4LjkgMCAyMjh2NTY4YzAgNTUuMiA0NC44IDEwMCAxMDAgMTAwaDgyNGM1NS4yIDAgMTAwLTQ0LjggMTAwLTEwMFYyMjhjMC0xOC41LTUuMS0zNS45LTEzLjktNTAuOEw1MTMgNjc0LjN6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/email.svg
// module id = +4G4
// module chunks = 72